import { TimelineActions } from '~src/store/timeline/constants';

const resetTimeline = () => ({
    type: TimelineActions.RESET,
});

export { resetTimeline };
